import axios from "axios";
import {} from "../constants/dataConstants";
import {} from "../constants/Utils";
import {
  FORECASTING_AC_CABEL_INSULATION_WEAKENING_FAIL,
  FORECASTING_AC_CABEL_INSULATION_WEAKENING_REQUEST,
  FORECASTING_AC_CABEL_INSULATION_WEAKENING_SUCCESS,
  FORECASTING_AC_LINE_LOSS_FAIL,
  FORECASTING_AC_LINE_LOSS_REQUEST,
  FORECASTING_AC_LINE_LOSS_SUCCESS,
  FORECASTING_CABEL_INSULATION_WEAKENING_FAIL,
  FORECASTING_CABEL_INSULATION_WEAKENING_REQUEST,
  FORECASTING_CABEL_INSULATION_WEAKENING_SUCCESS,
  FORECASTING_CONNECTOR_BOX_HEATING_FAIL,
  FORECASTING_CONNECTOR_BOX_HEATING_REQUEST,
  FORECASTING_CONNECTOR_BOX_HEATING_SUCCESS,
  FORECASTING_GALVANISATION_THICKNESS_FAIL,
  FORECASTING_GALVANISATION_THICKNESS_REQUEST,
  FORECASTING_GALVANISATION_THICKNESS_SUCCESS,
  FORECASTING_MODULE_DEGRADATION_FAIL,
  FORECASTING_MODULE_DEGRADATION_REQUEST,
  FORECASTING_MODULE_DEGRADATION_SUCCESS,
  FORECASTING_MODULE_HOTSPOT_FAIL,
  FORECASTING_MODULE_HOTSPOT_REQUEST,
  FORECASTING_MODULE_HOTSPOT_SUCCESS,
  FORECASTING_PLANT_AVAILABILITY_FAIL,
  FORECASTING_PLANT_AVAILABILITY_FAIL2,
  FORECASTING_PLANT_AVAILABILITY_REQUEST,
  FORECASTING_PLANT_AVAILABILITY_REQUEST2,
  FORECASTING_PLANT_AVAILABILITY_SUCCESS,
  FORECASTING_PLANT_AVAILABILITY_SUCCESS2,
  FORECASTING_PR_FAIL,
  FORECASTING_PR_REQUEST,
  FORECASTING_PR_SUCCESS,
    FORECASTING_SCBSMBSTRING_DEVIATION_FAIL,
  FORECASTING_SCBSMBSTRING_DEVIATION_REQUEST,
  FORECASTING_SCBSMBSTRING_DEVIATION_SUCCESS,
  FORECASTING_SOILING_LOSS_FAIL,
  FORECASTING_SOILING_LOSS_REQUEST,
  FORECASTING_SOILING_LOSS_SUCCESS,
  FORECASTING_TRANSFORMER_TEMPERATURE_FAIL,
  FORECASTING_TRANSFORMER_TEMPERATURE_REQUEST,
  FORECASTING_Transformer_TEMPERATURE_REQUEST,
  FORECASTING_TRANSFORMER_TEMPERATURE_SUCCESS,
} from "../constants/ForecastingDataConstants";

axios.defaults.baseURL =
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_SERVER_URL
    : "http://localhost:8000";

axios.defaults.withCredentials = true;


export const forecastingScbsmbStringDeviationAction =
  (detail, dateRange, databaseStr) => async (dispatch) => {
    try {
      const {dateRangeType:label, startTimestamp:startDate, endTimestamp:endDate, forecast } = dateRange;

      let {
        inverter,
        block,
        sub_block,
        scbsmb,
        scbsmbType,
        stack,
        heatmap,
      } = detail;

      inverter = inverter?.split(" ")[1] || null;
      block = block?.split(" ")[1] || null;
      sub_block = sub_block?.split(" ")?.slice(-1)[0] || null;
      scbsmb = scbsmb?.split(" ")[1] || null;
      stack = stack?.split(" ")[1] || null;

      dispatch({ type: FORECASTING_SCBSMBSTRING_DEVIATION_REQUEST });

      const { data } = await axios.post(`/predict/scbsmbstring-deviation`, {
        inverter,
        block,
        sub_block,
        scbsmb,
        scbsmbType,
        startDate,
        endDate,
        label,
        databaseStr,
        stack,
        heatmap,
        forecast
      });

      dispatch({
        type: FORECASTING_SCBSMBSTRING_DEVIATION_SUCCESS,
        payload: data?.result || null,
      });
    } catch (error) {
      dispatch({
        type: FORECASTING_SCBSMBSTRING_DEVIATION_FAIL,
        payload: error?.response?.data?.error || error.message,
      });
    }
  };

export const forecastingPrAction =
  (dateRange, databaseStr) => async (dispatch) => {
    try {
      const {
        dateRangeType: label,
        startTimestamp: startDate,
        endTimestamp: endDate,
        forecast
      } = dateRange;

      dispatch({ type: FORECASTING_PR_REQUEST });

      const { data } = await axios.post(`/predict/pr`, {
        startDate,
        endDate,
        label,
        forecast,
        databaseStr,
      });

      dispatch({
        type: FORECASTING_PR_SUCCESS,
        payload: data?.result || null,
      });
    } catch (error) {
      dispatch({
        type: FORECASTING_PR_FAIL,
        payload: error?.response?.data?.error || error.message,
      });
    }
  };

export const forecastingAcLineLossAction =
  (dateRange, databaseStr) => async (dispatch) => {
    try {
      const {
        dateRangeType: label,
        startTimestamp: startDate,
        endTimestamp: endDate,
        forecast
      } = dateRange;
      dispatch({ type: FORECASTING_AC_LINE_LOSS_REQUEST });

      const { data } = await axios.post(`/predict/ac-line-loss`, {
        startDate,
        endDate,
        label,
        databaseStr,
        forecast
      });

      dispatch({
        type: FORECASTING_AC_LINE_LOSS_SUCCESS,
        payload: data?.result || null,
      });
    } catch (error) {
      dispatch({
        type: FORECASTING_AC_LINE_LOSS_FAIL,
        payload: error?.response?.data?.error || error.message,
      });
    }
  };


  export const forecastingPlantAvailabilityAction =
  (dateRange, databaseStr) => async (dispatch) => {
    try {
      const {
        dateRangeType: label,
        startTimestamp: startDate,
        endTimestamp: endDate,
      } = dateRange;
      dispatch({ type: FORECASTING_PLANT_AVAILABILITY_REQUEST });

      const { data } = await axios.post(`/predict/plant-availability`, {
        startDate,
        endDate,
        label,
        databaseStr,
      });

      dispatch({
        type: FORECASTING_PLANT_AVAILABILITY_SUCCESS,
        payload: data?.result || null,
      });
    } catch (error) {
      dispatch({
        type: FORECASTING_PLANT_AVAILABILITY_FAIL,
        payload: error?.response?.data?.error || error.message,
      });
    }
  };



    export const forecastingPlantAvailabilityAction2 =
  (dateRange, databaseStr) => async (dispatch) => {
    try {
      const {
        dateRangeType: label,
        startTimestamp: startDate,
        endTimestamp: endDate,
        forecast
      } = dateRange;
      dispatch({ type: FORECASTING_PLANT_AVAILABILITY_REQUEST2 });

      const { data } = await axios.post(`/predict/pa`, {
        startDate,
        endDate,
        label,
        databaseStr,
        forecast
      });

      dispatch({
        type: FORECASTING_PLANT_AVAILABILITY_SUCCESS2,
        payload: data?.result || null,
      });
    } catch (error) {
      dispatch({
        type: FORECASTING_PLANT_AVAILABILITY_FAIL2,
        payload: error?.response?.data?.error || error.message,
      });
    }
  };


  export const forecastingModuleDegradationAction =
  (dateRange, databaseStr) => async (dispatch) => {
    try {
      const {
        dateRangeType: label,
        startTimestamp: startDate,
        endTimestamp: endDate,
        forecast
      } = dateRange;
      dispatch({ type: FORECASTING_MODULE_DEGRADATION_REQUEST });

      const { data } = await axios.post(`/predict/module-degradation`, {
        startDate,
        endDate,
        label,
        databaseStr,
        forecast
      });

      dispatch({
        type: FORECASTING_MODULE_DEGRADATION_SUCCESS,
        payload: data?.result || null,
      });
    } catch (error) {
      dispatch({
        type: FORECASTING_MODULE_DEGRADATION_FAIL,
        payload: error?.response?.data?.error || error.message,
      });
    }
  };

    export const forecastingSoilingLossAction =
  (dateRange, databaseStr) => async (dispatch) => {
    try {
      const {
        dateRangeType: label,
        startTimestamp: startDate,
        endTimestamp: endDate,
      } = dateRange;
      dispatch({ type: FORECASTING_SOILING_LOSS_REQUEST });

      const { data } = await axios.post(`/predict/soiling-loss`, {
        startDate,
        endDate,
        label,
        databaseStr,
      });

      dispatch({
        type: FORECASTING_SOILING_LOSS_SUCCESS,
        payload: data?.result || null,
      });
    } catch (error) {
      dispatch({
        type: FORECASTING_SOILING_LOSS_FAIL,
        payload: error?.response?.data?.error || error.message,
      });
    }
  };

export const forecastingTransformerTemperatureAction =
  (dateRange, databaseStr) => async (dispatch) => {
    try {
      const {
        dateRangeType: label,
        startTimestamp: startDate,
        endTimestamp: endDate,
      } = dateRange;
      dispatch({ type: FORECASTING_TRANSFORMER_TEMPERATURE_REQUEST });

      const { data } = await axios.post(`/predict/transformer-temperature`, {
        startDate,
        endDate,
        label,
        databaseStr,
      });

      dispatch({
        type: FORECASTING_TRANSFORMER_TEMPERATURE_SUCCESS,
        payload: data?.result || null,
      });
    } catch (error) {
      dispatch({
        type: FORECASTING_TRANSFORMER_TEMPERATURE_FAIL,
        payload: error?.response?.data?.error || error.message,
      });
    }
  };


export const forecastingCableInsulationAction =
  (dateRange, databaseStr) => async (dispatch) => {
    try {
      const {
        dateRangeType: label,
        startTimestamp: startDate,
        endTimestamp: endDate,
      } = dateRange;
      dispatch({ type: FORECASTING_CABEL_INSULATION_WEAKENING_REQUEST });

      const { data } = await axios.post(`/predict/cable-insulation-weakening`, {
        startDate,
        endDate,
        label,
        databaseStr,
      });

      dispatch({
        type: FORECASTING_CABEL_INSULATION_WEAKENING_SUCCESS,
        payload: data?.result || null,
      });
    } catch (error) {
      dispatch({
        type: FORECASTING_CABEL_INSULATION_WEAKENING_FAIL,
        payload: error?.response?.data?.error || error.message,
      });
    }
  };



  export const forecastingAcCableInsulationAction =
  (dateRange, databaseStr) => async (dispatch) => {
    try {
      const {
        dateRangeType: label,
        startTimestamp: startDate,
        endTimestamp: endDate,
      } = dateRange;
      dispatch({ type: FORECASTING_AC_CABEL_INSULATION_WEAKENING_REQUEST });

      const { data } = await axios.post(`/predict/ac-cable-insulation-weakening`, {
        startDate,
        endDate,
        label,
        databaseStr,
      });

      dispatch({
        type: FORECASTING_AC_CABEL_INSULATION_WEAKENING_SUCCESS,
        payload: data?.result || null,
      });
    } catch (error) {
      dispatch({
        type: FORECASTING_AC_CABEL_INSULATION_WEAKENING_FAIL,
        payload: error?.response?.data?.error || error.message,
      });
    }
  };
export const forecastingBoxConnectorHeatingAction =
  (dateRange, databaseStr) => async (dispatch) => {
    try {
      const {
        dateRangeType: label,
        startTimestamp: startDate,
        endTimestamp: endDate,
      } = dateRange;
      dispatch({ type: FORECASTING_CONNECTOR_BOX_HEATING_REQUEST });

      const { data } = await axios.post(`/predict/box-heating`, {
        startDate,
        endDate,
        label,
        databaseStr,
      });

      dispatch({
        type: FORECASTING_CONNECTOR_BOX_HEATING_SUCCESS,
        payload: data?.result || null,
      });
    } catch (error) {
      dispatch({
        type: FORECASTING_CONNECTOR_BOX_HEATING_FAIL,
        payload: error?.response?.data?.error || error.message,
      });
    }
  };


export const forecastingGalvanisationThicknessAction =
  (dateRange, databaseStr) => async (dispatch) => {
    try {
      const {
        dateRangeType: label,
        startTimestamp: startDate,
        endTimestamp: endDate,
      } = dateRange;
      dispatch({ type: FORECASTING_GALVANISATION_THICKNESS_REQUEST });

      const { data } = await axios.post(`/predict/galvanisation-thickness`, {
        startDate,
        endDate,
        label,
        databaseStr,
      });

      dispatch({
        type: FORECASTING_GALVANISATION_THICKNESS_SUCCESS,
        payload: data?.result || null,
      });
    } catch (error) {
      dispatch({
        type: FORECASTING_GALVANISATION_THICKNESS_FAIL,
        payload: error?.response?.data?.error || error.message,
      });
    }
  };


export const forecastingModuleHotspotAction =
  (dateRange, databaseStr) => async (dispatch) => {
    try {
      const {
        dateRangeType: label,
        startTimestamp: startDate,
        endTimestamp: endDate,
      } = dateRange;
      dispatch({ type: FORECASTING_MODULE_HOTSPOT_REQUEST });

      const { data } = await axios.post(`/predict/module-hotspot`, {
        startDate,
        endDate,
        label,
        databaseStr,
      });

      dispatch({
        type: FORECASTING_MODULE_HOTSPOT_SUCCESS,
        payload: data?.result || null,
      });
    } catch (error) {
      dispatch({
        type: FORECASTING_MODULE_HOTSPOT_FAIL,
        payload: error?.response?.data?.error || error.message,
      });
    }
  };



